var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "dashboard-v3" },
      [
        _c("agent-card", {
          attrs: {
            user: _vm.user,
            profile: _vm.profile,
            loadingUser: _vm.loadingUser,
            loadingProfile: _vm.loadingProfile
          }
        }),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: 40 } },
          _vm._l(_vm.cardInfo, function(info, i) {
            return _c("CardInfo", {
              key: i,
              attrs: {
                info: info,
                cardKey: i,
                loadingProfile: _vm.loadingProfile
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("el-row", [
          _c(
            "div",
            {
              staticClass:
                "card-style card-softstyle enter-animation barchart-card animationdelay-7s"
            },
            [
              _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _vm.values.length
                    ? _c("bar-chart", {
                        ref: "barChart",
                        attrs: {
                          labels: _vm.labels,
                          values: _vm.values,
                          placeholder: _vm.$t("dashboard.agent.SmsSent"),
                          "chart-title": _vm.$t("dashboard.agent.top5Orgs"),
                          barColor: "#2d527c"
                        }
                      })
                    : _c("div", [
                        _c("div", { staticClass: "graph-title" }, [
                          _vm._v(_vm._s(_vm.$t("dashboard.agent.top5Orgs")))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "no-data" }, [
                          _vm._v(_vm._s(_vm.$t("common.noData")))
                        ])
                      ])
                ],
                1
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }